import { CanadaOperationTaxes } from '../operation-taxes'

export const OntarioOperationTaxes = {
  ...CanadaOperationTaxes,
} as const
